import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { LaunchUrgency } from './components/LaunchUrgency';
import { Offer } from './components/Offer';
import { TestimonialWall } from './components/TestimonialWall';
import { Guarantee } from './components/Guarantee';
import { Faqs } from './components/Faqs';
import { Comparison } from './components/Comparison';
import { FinalCall } from './components/FinalCall';
import { ClosingWords } from './components/ClosingWords';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="3iiwdijzxza14">
      <noscript data-id="element-1" data-mp="3ii4ppvcl6gle">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3mlat8v8bdto6" />
      </noscript>
      <Hero data-id="element-3" data-mp="4wupmfw6qeo" />
      <SocialProofBar data-id="element-4" data-mp="4n7g6m8exco" />
      <QuickTestimonials data-id="element-5" data-mp="82kl3wchwbg" />
      <Problems data-id="element-6" data-mp="2zld0z6e9z99y" />
      <SystemOverview data-id="element-7" data-mp="2zlv6ktmtuzuj" />
      <Volumes data-id="element-8" data-mp="2zmenq84nlk7i" />
      <Bonuses data-id="element-9" data-mp="2zmwit1fkxsdu" />
      <LaunchUrgency data-id="element-10" data-mp="2zng14j956ise" />
      <Offer data-id="element-11" data-mp="33mf1rrnubte1" />
      <TestimonialWall data-id="element-12" data-mp="33lwy49yumcw3" />
      <Guarantee data-id="element-13" data-mp="33ngfy505kvzz" />
      <Faqs data-id="element-14" data-mp="33mylndx1wrup" />
      <Comparison data-id="element-15" data-mp="33oi2b5mmd4x0" />
      <FinalCall data-id="element-16" data-mp="38m1gk5jbhhoy" />
      <ClosingWords data-id="element-17" data-mp="38li8dgjgy7o4" />
      <SiteFooter data-id="element-18" data-mp="38l06o4e1f18t" />
    </div>;
}